import {ConfigsProperties} from './index'

const config: ConfigsProperties = {
    BASE_API: 'http://172.25.18.48:19010/',
    SHA1_SALT: '6sJJnUiq',
    QINIU_HOST: 'http://cdn-srm-test.xmiws.com/',
    MINIO_HOST: 'http://222.76.241.251:29000/fosun/',
    ENV_NAME: '测试环境'
}

export default config
